import { getDomainInfo } from '@tribeplatform/react-components/common/utils'

import { InjectedAppProps } from '../server/types/server.types.js'

import { useHardRefresh } from './entry/hooks/useHardRefresh.js'
import { usePrivateNetworkGuard } from './entry/hooks/usePrivateNetworkGuard.js'
import { useRedirectAuthUser } from './entry/hooks/useRedirectAuthUser.js'
import { useRedirectUnconfirmedUser } from './entry/hooks/useRedirectUnconfirmedUser.js'

/** Client-side navigation guards applied globally from the root route.
 * Handles auth redirects, private network access, email confirmation,
 * and hard refreshes for auth paths.
 */
export function useGuard({
  injectedAppProps,
}: {
  injectedAppProps: InjectedAppProps
}) {
  const { domain, domainSubfolder } = injectedAppProps?.network ?? {}
  const { subfolder } = getDomainInfo({
    domain,
    domainSubfolder,
  })
  const roleType = injectedAppProps?.authMember?.role?.type
  const visibility = injectedAppProps?.network?.visibility
  const emailStatus = injectedAppProps?.authMember?.emailStatus
  const memberId = injectedAppProps?.authMember?.id

  useHardRefresh({ pathPrefixes: ['/auth/'], subfolder })
  usePrivateNetworkGuard(roleType, visibility)
  useRedirectAuthUser(roleType)
  useRedirectUnconfirmedUser({ emailStatus, roleType, memberId })
}
